package com.partejar.app.feature.relacionamentos.presentation

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.selection.selectableGroup
import androidx.compose.material3.FilterChip
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.partejar.app.core.ui.theme.PartejarShapes
import com.partejar.app.core.ui.theme.PartejarTheme
import com.partejar.app.feature.relacionamentos.data.RelationshipOrigin

@Composable
internal fun RelationshipOriginField(value: String?, onValueChange: (String?) -> Unit, enabled: Boolean = true) {
    val spacing = PartejarTheme.spacing
    Column(verticalArrangement = Arrangement.spacedBy(spacing.space8)) {
        Text("Origem do contato (opcional)", style = MaterialTheme.typography.titleMedium)
        FlowRow(
            modifier = Modifier.selectableGroup(),
            horizontalArrangement = Arrangement.spacedBy(spacing.space8),
            verticalArrangement = Arrangement.spacedBy(spacing.space8)
        ) {
            (listOf<String?>(null) + RelationshipOrigin.entries.map { it.apiValue }).forEach { origin ->
                FilterChip(
                    label = { Text(relationshipOriginLabel(origin)) },
                    selected = value == origin,
                    onClick = { onValueChange(origin) },
                    enabled = enabled,
                    shape = PartejarShapes.pill,
                    modifier = Modifier.heightIn(min = PartejarTheme.dimensions.minimumTouchTarget)
                )
            }
        }
        if (value != null && RelationshipOrigin.entries.none { it.apiValue == value }) {
            Text(relationshipOriginLabel(value), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
        }
    }
}
